

import ridima from "../assets/ridima.jpeg"
import mauri from "../assets/mauri.jpeg"
import harsh from "../assets/harshal.jpeg"
import riddhi from "../assets/riddhi.jpeg"
import sonal from "../assets/sonal.jpeg"
import raman from "../assets/raman.jpeg"
import kumar from "../assets/kumar.jpeg"
import dipti from "../assets/dipti.jpeg"
import sangeeta from "../assets/sangeeta.jpeg"
import swati from "../assets/swati.jpeg"
import neha from "../assets/neha.jpeg"
import meghna from "../assets/meghna.jpeg"
import sharvari from "../assets/sharvari.jpeg"
import tejashri from "../assets/tejashri.jpeg"
import vaishali from "../assets/vaishali.jpeg"
import mamta from "../assets/mamta.jpeg"
import shubangi from "../assets/shubangi.jpeg"
import nilangana from "../assets/nilangana.jpeg"
import pournima from "../assets/pournima.jpeg"
import rupali from "../assets/rupali.jpeg"










export const testimonialsData = [
  {
    image: ridima,
    review:
      "Hey, I am Ridima. When I joined, I was 70.5 kg, and today I am 65.8 kg. From XL, I have come to M size. Seriously, I am very lucky to have you in my life. Along with body toning, my mind toning is done automatically. Thank you so much for making me meet myself.",
    name: 'Ridima',
    // status : 'ENTREPRENEUR'
  },
  {
    image: kumar,
    review: 'Hey Gita, thanks to you, my diabetes levels are now normal, and I feel more energized with less sleep. The doctor reduced my medicines by 50%, and I am experiencing positive changes in various aspects of my health. Joining your class was a life-changing decision. Thank you! 🙂 ',
    name: 'Kumar',
    // status: 'COACH'
  },
  {
    image : sonal,
    review:'Achieved great results from June to October, going from 72 kg to 59 kg, all thanks to Geetanjali Kandale. I am so fit now that people are often surprised when they see me. Maintaining a healthy diet and regular exercise is crucial for my well-being. Never neglect your mental health.',
    name: 'Sonal',
    // status: "CUSTOMER"
  },

  {
    image: harsh,
    review:
      "Hey, I am Harshal. Geetanjali, your guidance has transformed my life. With normalized diabetes levels, increased energy on less sleep, and a 50% reduction in medication, I owe it all to your classes. It's been a life-changing decision, and I can't thank you enough! 🙂",
    name: 'Harshal',
    // status : 'ENTREPRENEUR'
  },
  {
    image: rupali,
    review: 'Hey, I am Ruplai. I am following the diet plan, and you said to update my weight on Friday. Today is Thursday, and I am 66.80 kg 😍😍, very very happy. With my doctors permission, I have been taking half a BP tablet for the last 8 days, and my BP is normal. Thank you so much for making me meet myself',
    name: 'Rupali',
    // status: 'COACH'
  },
  {
    image : raman,
    review:'Joined the class last year weighing 67 kg and lost 10 kg in a year. Weight remains constant now. After a 2-month break, still no weight gain. In Geetas class for 1.5 years, solved many problems. Gained muscle strength, energy, overall happiness, and health.',
    name: 'Raman',
    // status: "CUSTOMER"
  },

  {
    image: pournima,
    review:
      "Hey, I am Pornima. When I joined, I was 70.5 kg, and today I am 65.8 kg. From XL size, I have come to M size. Seriously, I am very lucky to have you in our life. Along with body toning, my mind toning is done automatically. Thank you so much for making me meet myself.",
    name: 'Pornima',
    // status : 'ENTREPRENEUR'
  },
  {
    image: mauri,
    review: 'Hey, I am Mauri. I visited my doctor, and he is pleased with my progress. He suggested reducing my Tyronorm dosage from 50 to 25. We will monitor for three months and adjust based on the blood test results. Grateful for the positive changes happening for me. ',
    name: 'Mauri',
    // status: 'COACH'
  },
  {
    image : dipti,
    review:'Hey, I am Dipti. Hi Mam, I visited my doctor, and he is very happy. He said to adjust my Tyronorm dosage to 25 instead of 50. We’ll observe for 3 months and make necessary changes based on the blood test results. Thanks, Mam 🙏🏻. I am very happy everything is working together for me 😊.',
    name: 'Dipti',
    // status: "CUSTOMER"
  },

  {
    image: riddhi,
    review:
      "Hey, I am Riddhi. Good morning! I've been diligently following the diet plan. According to your advice, I update my weight on Fridays, but today is Thursday. With my doctor's approval, I’ve been taking half of the prescribed blood pressure tablet, and my blood pressure is now normal. 👍",
    name: 'Riddhi',
    // status : 'ENTREPRENEUR'
  }

  ,

  {
    image:sangeeta ,
    review:
'I am Sangeeta Nikam, and I joined Geeta Mams class on 5th July. As an obese person since childhood and a diabetic for 12 years, I had given up on exercising and dieting. But Geeta Mams motivation and guidance have helped me make significant progress: I can now sit on the floor after 5 years, and have lost 7 kg and 2 inches in belly and arms. Thanks to Geeta Mam, I am on track to achieving my goals! 🙏🏻',
    name: 'Sangeeta Nikam',
    // status : 'ENTREPRENEUR'
  },
  {
    image:swati ,
    review: 
'I am really happy to share my amazing experience with Geeta Mams yoga class! I started going to her class because I was having problems with my periods and hormones, but since I have been practicing with her, I have seen a big difference. She is a great teacher who really knows what she is doing, and she helps you personally. I am so thankful for how much better I feel now. If you are having similar problems, I definitely recommend going to Geeta Mams class - it is been a game-changer for me!"',
    name: 'Swati',
    // status: 'COACH'
  },
  {
    image :neha,
    review:
    'I am deeply grateful for your guidance and support in helping me achieve 108 Surya Namaskar on Yoga Day. Your belief in me and commitment to my growth have been instrumental in this accomplishment. Thank you for pushing me beyond my limits and instilling discipline and mindfulness through yoga, significantly impacting my physical well-being and inner peace. I am fortunate to have you as my mentor.',
        name: 'Neha',
    // status: "CUSTOMER"
  },

  {
    image:meghna ,
    review:
'I am thrilled to share my experience with Geeta Mams class, which has been a game-changer for me! After trying various diet plans and exercises with no success, I was frustrated and struggling with back pain and other health issues. But Geeta Mams personalized guidance on exercise and diet has brought me immense relief, mental strength, and a newfound energy. I am loving my new shape and overall well-being. Thank you, Geeta Mam! ❤️💓',
    name: 'Meghna',
    // status : 'ENTREPRENEUR'
  },



  {
    image: sharvari,
    review:
    'Im Sharvari Here to share my experience. I was never fit, and my weight increased with age. Nothing worked until I met Geeta. I joined her class, followed a proper diet, and started exercising. Despite a knee injury, I continued with Geetas motivation. In 4 to 5 months, I lost 17kg and reached 69kg. Now, after surgery, Im able to walk with a walker and feel fit. Thanks to Geeta Stay Healthy Stay Fit!',
       name: 'Sharvari',
    // status : 'ENTREPRENEUR'
  },
  {
    image:tejashri ,
    review: 'Hi, Im Tejashree. I met Geeta mam in 2023, but I didnt follow her diet plan initially. I even stopped attending classes, but my friend Riddhis status updates kept me motivated. I saw her progress and decided to follow Geeta mams diet plan. I joined on February 5th, weighing 78 kg, and by March 19th, I had lost 8 kg, reaching 70 kg. I was amazed by my progress! Despite some setbacks, Ive now reached 68 kg and Im determined to reach my ideal weight. Thank you, Geeta mam, for your guidance and support. I wont give up! 😊',
    name: 'Tejashree',
    // status: 'COACH'
  },
  {
    image : vaishali,
    review:
    'Im Vaishali, and I joined Geetanjali Mams class when I was struggling with obesity. Mam has done a great job, and I am thrilled to say that I have managed to reduce my weight by half! I am feeling incredibly happy and proud of myself for achieving this milestone, and I owe it all to Geetanjali Mams guidance and support - thanks to her, I have been able to transform my life for the better! ',
      name: 'Vaishali',
    // status: "CUSTOMER"
  },

  {
    image: mamta,
    review:
    'Im Mamta, 40, overweight since pregnancy, working a 9-6 desk job. I weighed 102kg in April 2023 when I joined Geeta Mams program with uncontrolled thyroid, severe acidity, pre-diabetes, and borderline cholesterol. Despite irregular attendance, Geeta Mams motivation helped me reverse my health issues and lose weight. After a break due to my fathers passing, I refocused on my health. Ive made progress: TSH 10.64 to 6.22, weight 102kg to 94kg, lost 7.25 inches, and improved my cholesterol and diabetes status. I credit Geeta Maam for my progress and feel blessed to have found her.',
      name: 'Mamta',
    // status : 'ENTREPRENEUR'
  },

  {
    image : shubangi,
    review:
'Im thrilled to share that my journey with Geeta mam has brought me more than just weight loss. My ankle pain has significantly reduced, allowing me to do exercises like skipping, jumping jacks, and vajrasan without any issues. I was previously unable to do these, but now I can enjoy them freely! There are many more benefits Ive experienced, and Im grateful for Geeta mams guidance. Thank you again, Geetanjali madam, for your support and motivation! 🙏🙏🌹🌹',
 name: 'Shubangi Talankar',
    // status: "CUSTOMER"
  },

  {
    image: nilangana,
    review:
"I'm Rupa De, and I'm thrilled to share my transformation story! A year ago, I struggled with thyroid, PCOS, uric acid, and a low hemoglobin level of 5. But with Geeta mam's guidance and motivation, I've made a remarkable recovery. I followed her diet plan diligently, even giving up sweets 🤭, and now I've reached my ideal weight. I'm happier and healthier than ever, and I credit it all to Geeta mam 🙏❤️!"   ,
 name: 'Rupa de',
    // status : 'ENTREPRENEUR'
  }
];
